<div class="row" style="padding-top: 5px">
  <div class="col-md-12 overflow-auto">
    <div class="col-md-12">
      <div class="col-md-12 col-xs-12">
        <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        (firstDataRendered)="restoreGridState($event)"
        (paginationChanged)="saveGridState($event)"
        (sortChanged)="saveGridState($event)"
        [columnDefs]="columnDefs"
        [rowData]="reports"
        [domLayout]="'autoHeight'"
        [pagination]= "true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
